import { render, staticRenderFns } from "./CMSEmptyDetail.vue?vue&type=template&id=4e799131&"
import script from "./CMSEmptyDetail.vue?vue&type=script&lang=js&"
export * from "./CMSEmptyDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports